/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.FolderTree";
        const DEFAULT_ICON_CLOSED_FOLDER = "wpt-font wpt-font-folder";
        const DEFAULT_ICON_DOCUMENT = "wpt-font wpt-font-icon_Doc";
        const DEFAULT_ICON_OPEN_FOLDER = "wpt-font wpt-font-folder_open";
        const DEFAULT_ICON_SEARCH = "wpt-font wpt-font-search";
        class FolderTreeWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("FolderTreeWidgetTypeClass.createInstance()");
                    return new FolderTreeWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("FolderTreeWidgetTypeClass._storeHtml()");
                    FolderTreeWidgetInstanceClass.HtmlData = htmlData;
                    if (FolderTreeWidgetInstanceClass.ModalHtmlData != null) {
                        this._presentInstances();
                    }
                };
                this._storeSelectionHtml = (htmlData) => {
                    this._log.info("FolderTreeWidgetTypeClass._storeSelectionHtml()");
                    FolderTreeWidgetInstanceClass.ModalHtmlData = htmlData;
                    if (FolderTreeWidgetInstanceClass.HtmlData != null) {
                        this._presentInstances();
                    }
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("FolderTreeWidgetTypeClass::constructor");
                if (FolderTreeWidgetInstanceClass.HtmlData != null && FolderTreeWidgetInstanceClass.ModalHtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    if (FolderTreeWidgetInstanceClass.HtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/FolderTree/folder-tree.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                    if (FolderTreeWidgetInstanceClass.ModalHtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/FolderTree/folder-tree-selection.html', this._storeSelectionHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
        }
        Widgets.FolderTreeWidgetTypeClass = FolderTreeWidgetTypeClass;
        class FolderTreeWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._holder = null;
                this._dataTree = null;
                this._openedFolderIcon = DEFAULT_ICON_OPEN_FOLDER;
                this._closedFolderIcon = DEFAULT_ICON_CLOSED_FOLDER;
                this._documentIcon = DEFAULT_ICON_DOCUMENT;
                this._searchIcon = DEFAULT_ICON_SEARCH;
                this._displayDocumentsBeforeFolders = false;
                this._maxFolders = null;
                this._maxDocuments = null;
                this._filterPanel = null;
                this._filterInput = null;
                this._showFilterInput = null;
                this._hideFilterInput = null;
                this._nodeToLoad = null;
                this._currentFolderSelectionModalSession = null;
                this._currentDocumentSelectionModalSession = null;
                this._modalFolderSearchTitle = null;
                this._modalDocumentSearchTitle = null;
                this._modalDataTree = null;
                this._modalMoreResults = null;
                this._modalNoChild = null;
                this._modalNoDocument = null;
                this._modalClose = null;
                this._activateIntoSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this.presentInstance = () => {
                    this._log.info("FolderTreeWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = FolderTreeWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._holder = this._container.querySelector('#folderTreeHolder');
                    this._filterPanel = this._container.querySelector('.widget__filter');
                    this._filterInput = this._filterPanel.querySelector('#folderTreeFilter');
                    this._showFilterInput = this._container.querySelector('.showFolderTreeOptions');
                    this._hideFilterInput = this._container.querySelector('.hideFolderTreeOptions');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#folderTreeTitle'), 'STR_WPT_FOLDERS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslationAttribute(this._filterInput, 'placeholder', 'STR_WPT_FOLDERDOCFILTER');
                    this._core.Helper.setElementTranslationAttribute(this._filterInput, 'aria-label', 'STR_WPT_FOLDERDOCFILTER');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#folderTreeLoading'), 'STR_WPT_LOADING');
                    this._modalFolderSearchTitle = this._core.Locale.getTranslation('STR_WPT_FOLDERFOLDERSELECTIONTITLE');
                    this._modalDocumentSearchTitle = this._core.Locale.getTranslation('STR_WPT_FOLDERDOCSELECTIONTITLE');
                    this._modalMoreResults = this._core.Locale.getTranslation('STR_WPT_FOLDERMORESEARCHRESULTS');
                    this._modalNoChild = this._core.Locale.getTranslation('STR_WPT_FOLDERNOFOLDERFOUND');
                    this._modalNoDocument = this._core.Locale.getTranslation('STR_WPT_FOLDERNODOCUMENTFOUND');
                    this._modalClose = this._core.Locale.getTranslation('STR_WPT_CLOSE');
                    this._filterInput.addEventListener('keyup', this._filterDocuments);
                    this._showFilterInput.addEventListener('click', this._showFilter);
                    this._hideFilterInput.addEventListener('click', this._hideFilter);
                    this._container.querySelector('.folderTreeClearFilter').addEventListener('click', this._clearFilterDocuments);
                    let treeConfig = {
                        LoadNodeCallback: this._loadFolderContent,
                        SelectLeafCallback: this._documentSelected,
                        SearchNodeCallback: this._searchFolder,
                        SearchLeafCallback: this._searchDocument,
                        NodeIconOpened: this._openedFolderIcon,
                        NodeIconClosed: this._closedFolderIcon,
                        LeafIcon: this._documentIcon,
                        SearchIcon: this._searchIcon,
                        DisplayLeavesBeforeNodes: this._displayDocumentsBeforeFolders,
                        MaxNodes: this._maxFolders,
                        MaxLeaves: this._maxDocuments
                    };
                    treeConfig.NodeSearchText = this._core.Locale.getTranslation('STR_WPT_FOLDERFOLDERSEARCH');
                    treeConfig.LeafSearchText = this._core.Locale.getTranslation('STR_WPT_FOLDERDOCSEARCH');
                    this._dataTree = new Widgets.ComponentDataTree(this._core, this._holder, this, treeConfig);
                    this._dataTree.present();
                    this._presentFolders();
                    this._type.instanceReady(this.getHandle());
                };
                this._presentFolders = () => {
                    this._log.info("FolderTreeWidgetInstanceClass._presentFolders()");
                    let config = this._config;
                    if (config.hasOwnProperty('RootFolder') && config.RootFolder.length > 0) {
                        this._core.Functions.showElement(this._loader);
                        let request = {
                            FolderPath: config.RootFolder
                        };
                        this._core.Loader.genericServiceCallWithData('/Folders.svc/rest/GetFolderByPath', JSON.stringify(request), this._presentRootFolder, null, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        console.warn("no 'RootFolder' configured for FolderTree widget");
                    }
                };
                this._presentRootFolder = (folderResponse) => {
                    this._log.info("FolderTreeWidgetInstanceClass._presentRootFolder()");
                    this._core.Functions.hideElement(this._loader);
                    let treeData = this._convertRootFolderToDataTree(folderResponse);
                    this._dataTree.displayData(treeData);
                    if (this._nodeToLoad) {
                        this._loadFolderContent(this._nodeToLoad);
                        this._nodeToLoad = null;
                    }
                };
                this._convertRootFolderToDataTree = (folderResponse) => {
                    this._log.info("FolderTreeWidgetInstanceClass._convertRootFolderToDataTree()");
                    let result = {
                        Id: Widgets.TREE_ROOT,
                        DisplayName: Widgets.TREE_ROOT,
                        Leaves: [],
                        Nodes: [],
                        Loaded: true
                    };
                    let rootFolder = folderResponse.Folder;
                    let config = this._config;
                    if (config.hasOwnProperty('UseSingleChildFolderAsRoot') && config.UseSingleChildFolderAsRoot && rootFolder.Documents.length == 0 && rootFolder.Children.length == 1) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using single child folder as root");
                        }
                        let newRoot = this._convertFolderInfoToNodeData(rootFolder.Children[0]);
                        newRoot.DisplayOpened = true;
                        result.Nodes.push(newRoot);
                        this._nodeToLoad = rootFolder.Children[0].Id.toString(10);
                    }
                    else if (rootFolder.FolderInfo.Id == 0) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got root folder with id '0'");
                        }
                        let children = rootFolder.Children;
                        let childrenLength = children.length;
                        for (let i = 0; i < childrenLength; i++) {
                            let folderInfo = children[i];
                            let newNode = this._convertFolderInfoToNodeData(folderInfo);
                            result.Nodes.push(newNode);
                        }
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got 'normal' folder as root");
                        }
                        let omitRootFolder = config.hasOwnProperty('OmitRootFolder') && config.OmitRootFolder;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("omit root folder? " + omitRootFolder);
                        }
                        let rootNode = result;
                        if (!omitRootFolder) {
                            rootNode = this._convertFolderInfoToNodeData(rootFolder.FolderInfo);
                            result.Nodes.push(rootNode);
                        }
                        else {
                            // set root folder id even for omit root folder (searches can't work otherwise)
                            rootNode.Id = rootFolder.FolderInfo.Id.toString(10);
                        }
                        this._addDocuments(rootNode, rootFolder.Documents, rootFolder.HasMoreDocuments);
                        this._addChildren(rootNode, rootFolder.Children, rootFolder.HasMoreChildren);
                    }
                    return result;
                };
                this._convertFolderInfoToNodeData = (folderInfo) => {
                    this._log.info("FolderTreeWidgetInstanceClass._convertFolderInfoToNodeInfo()");
                    let result = {
                        Id: folderInfo.Id.toString(10),
                        DisplayName: folderInfo.Name,
                        Loaded: false
                    };
                    return result;
                };
                this._convertDocumentToLeafData = (doc) => {
                    this._log.info("FolderTreeWidgetInstanceClass._convertDocumentToLeafData()");
                    let result = {
                        Id: doc.ItemNum.toString(10),
                        DisplayName: doc.Name
                    };
                    return result;
                };
                this._addDocuments = (rootNode, documents, hasMoreDocuments = false) => {
                    this._log.info("FolderTreeWidgetInstanceClass._addDocuments()");
                    rootNode.HasMoreLeaves = hasMoreDocuments;
                    let leaves = [];
                    rootNode.Leaves = leaves;
                    if (documents != null && documents != undefined && documents.length > 0) {
                        let documentsLength = documents.length;
                        for (let i = 0; i < documentsLength; i++) {
                            let doc = documents[i];
                            let leaf = this._convertDocumentToLeafData(doc);
                            leaves.push(leaf);
                        }
                    }
                };
                this._addChildren = (rootNode, children, hasMoreChildren = false) => {
                    this._log.info("FolderTreeWidgetInstanceClass._addChildren()");
                    rootNode.HasMoreNodes = hasMoreChildren;
                    let nodes = [];
                    rootNode.Nodes = nodes;
                    if (children != null && children != undefined && children.length > 0) {
                        let childLength = children.length;
                        for (let i = 0; i < childLength; i++) {
                            let folder = children[i];
                            let node = this._convertFolderInfoToNodeData(folder);
                            nodes.push(node);
                        }
                    }
                };
                this._loadFolderContent = (folderId) => {
                    this._log.info("FolderTreeWidgetInstanceClass._loadFolderContent()");
                    this._core.Functions.showElement(this._loader);
                    let url = '/Folders.svc/rest/GetFolderById/' + folderId;
                    this._core.Loader.genericServiceCall(url, this._addFolder, this._callErrorHandler, this._callFailedHandler);
                };
                this._addFolder = (folderData) => {
                    this._log.info("FolderTreeWidgetInstanceClass._addFolder()");
                    let folder = folderData.Folder;
                    let nodeData = this._convertFolderInfoToNodeData(folder.FolderInfo);
                    this._addDocuments(nodeData, folder.Documents, folder.HasMoreDocuments);
                    this._addChildren(nodeData, folder.Children, folder.HasMoreChildren);
                    this._core.Functions.hideElement(this._loader);
                    this._dataTree.appendData(nodeData);
                };
                this._documentSelected = (docId) => {
                    this._log.info("FolderTreeWidgetInstanceClass._documentSelected()");
                    this._dataTree.clearLeafSelection();
                    this._dataTree.selectLeaf(docId);
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = +docId;
                    navEvent.Slots = this._activateIntoSlots;
                    let config = this._config;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "DocumentView";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._searchFolder = (folderId, searchValue) => {
                    this._log.info("FolderTreeWidgetInstanceClass._searchFolder()");
                    let request = {
                        FolderId: +folderId,
                        SearchValue: searchValue
                    };
                    let requestData = JSON.stringify(request);
                    this._core.Loader.genericServiceCallWithData('/Folders.svc/rest/GetChildFoldersBySearch', requestData, this._presentChildFolderSearchModal.bind(this, searchValue), null, this._callErrorHandler, this._callFailedHandler);
                };
                this._presentChildFolderSearchModal = (search, folderData) => {
                    this._log.info("FolderTreeWidgetInstanceClass._presentChildFolderSearchModal()");
                    let folder = folderData.Folder;
                    let modalSession = 'folder-selection-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentFolderSelectionModalSession = modalSession;
                        modal.DIV.innerHTML = FolderTreeWidgetInstanceClass.ModalHtmlData;
                        let holder = modal.DIV.querySelector('#folderTreeHolder');
                        modal.DIV.querySelector('#folderTreeSelectionHeading').innerHTML = this._modalFolderSearchTitle + '"' + search + '"';
                        modal.DIV.querySelector('#folderTreeSelectionCloseButtonLabel').innerHTML = this._modalClose;
                        modal.DIV.querySelector('#closeIcon').setAttribute('title', this._modalClose);
                        modal.DIV.querySelector('#closeIcon').setAttribute('aria-label', this._modalClose);
                        let treeData = {
                            Id: Widgets.TREE_ROOT,
                            DisplayName: Widgets.TREE_ROOT,
                            Leaves: [],
                            Nodes: [],
                            Loaded: true
                        };
                        let resultFolder = this._convertFolderInfoToNodeData(folder.FolderInfo);
                        resultFolder.Loaded = true;
                        this._addChildren(resultFolder, folder.Children, folder.HasMoreChildren);
                        resultFolder.Leaves = [];
                        resultFolder.HasMoreLeaves = false;
                        treeData.Nodes.push(resultFolder);
                        let treeConfig = {
                            SelectNodeCallback: this._folderResultSelected.bind(this, folder.FolderInfo.Id.toString(10), resultFolder.Nodes),
                            NodeIconOpened: this._openedFolderIcon,
                            NodeIconClosed: this._closedFolderIcon,
                            MoreNodesText: this._modalMoreResults,
                            NoNodesText: this._modalNoChild
                        };
                        this._modalDataTree = new Widgets.ComponentDataTree(this._core, holder, this, treeConfig);
                        this._modalDataTree.present();
                        this._modalDataTree.displayData(treeData);
                        this._core.showModal(modalSession);
                    }
                };
                this._folderResultSelected = (parentId, nodes, resultId) => {
                    this._log.info("FolderTreeWidgetInstanceClass._folderResultSelected()");
                    if (resultId == parentId) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("parent folder clicked, do nothing");
                        }
                        return;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("selected folder: " + resultId);
                    }
                    let length = nodes.length;
                    for (let i = 0; i < length; i++) {
                        let node = nodes[i];
                        if (node.Id == resultId) {
                            this._dataTree.addNodeSearchResult(parentId, node);
                            this._core.hideModal(this._currentFolderSelectionModalSession);
                            return;
                        }
                    }
                };
                this._searchDocument = (folderId, searchValue) => {
                    this._log.info("FolderTreeWidgetInstanceClass._searchDocument()");
                    let request = {
                        FolderId: +folderId,
                        SearchValue: searchValue
                    };
                    let requestData = JSON.stringify(request);
                    this._core.Loader.genericServiceCallWithData('/Folders.svc/rest/GetDocumentsBySearch', requestData, this._presentDocumentSearchModal.bind(this, searchValue), null, this._callErrorHandler, this._callFailedHandler);
                };
                this._presentDocumentSearchModal = (search, folderData) => {
                    this._log.info("FolderTreeWidgetInstanceClass._presentDocumentSearchModal()");
                    let folder = folderData.Folder;
                    let modalSession = 'document-selection-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentDocumentSelectionModalSession = modalSession;
                        modal.DIV.innerHTML = FolderTreeWidgetInstanceClass.ModalHtmlData;
                        let holder = modal.DIV.querySelector('#folderTreeHolder');
                        modal.DIV.querySelector('#folderTreeSelectionHeading').innerHTML = this._modalDocumentSearchTitle + '"' + search + '"';
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), "title", 'STR_WPT_CLOSE');
                        this._core.Helper.setElementTranslationAttribute(modal.DIV.querySelector('#closeIcon'), "aria-label", 'STR_WPT_CLOSE');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#folderTreeSelectionCloseButton'), 'STR_WPT_CLOSE');
                        let treeData = {
                            Id: Widgets.TREE_ROOT,
                            DisplayName: Widgets.TREE_ROOT,
                            Leaves: [],
                            Nodes: [],
                            Loaded: true
                        };
                        let resultFolder = this._convertFolderInfoToNodeData(folder.FolderInfo);
                        resultFolder.Loaded = true;
                        this._addDocuments(resultFolder, folder.Documents, folder.HasMoreDocuments);
                        resultFolder.Nodes = [];
                        resultFolder.HasMoreNodes = false;
                        treeData.Nodes.push(resultFolder);
                        let treeConfig = {
                            SelectLeafCallback: this._documentResultSelected.bind(this, folder.FolderInfo.Id.toString(10), resultFolder.Leaves),
                            SelectNodeCallback: id => { return; },
                            NodeIconOpened: this._openedFolderIcon,
                            LeafIcon: this._documentIcon,
                            MoreLeavesText: this._modalMoreResults,
                            NoLeavesText: this._modalNoDocument
                        };
                        this._modalDataTree = new Widgets.ComponentDataTree(this._core, holder, this, treeConfig);
                        this._modalDataTree.present();
                        this._modalDataTree.displayData(treeData);
                        this._core.showModal(modalSession);
                    }
                };
                this._documentResultSelected = (parentId, leaves, resultId) => {
                    this._log.info("FolderTreeWidgetInstanceClass._documentResultSelected()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("selected document: " + resultId);
                    }
                    let length = leaves.length;
                    for (let i = 0; i < length; i++) {
                        let leaf = leaves[i];
                        if (leaf.Id == resultId) {
                            this._dataTree.addLeafSearchResult(parentId, leaf);
                            this._core.hideModal(this._currentDocumentSelectionModalSession);
                            return;
                        }
                    }
                };
                this._showFilter = () => {
                    this._log.info("FolderTreeWidgetInstanceClass._showFilter()");
                    this._core.Functions.hideElement(this._showFilterInput);
                    this._core.Functions.showElement(this._hideFilterInput);
                    this._core.Functions.showElement(this._filterPanel);
                    this._filterInput.focus();
                };
                this._hideFilter = () => {
                    this._log.info("FolderTreeWidgetInstanceClass._hideFilter()");
                    this._clearFilterDocuments();
                    this._core.Functions.hideElement(this._filterPanel);
                    this._core.Functions.hideElement(this._hideFilterInput);
                    this._core.Functions.showElement(this._showFilterInput);
                };
                this._clearFilterDocuments = () => {
                    this._log.info("FolderTreeWidgetInstanceClass._clearFilterDocuments()");
                    this._core.Functions.clearInputElement(this._filterInput);
                    this._filterDocuments();
                };
                this._filterDocuments = () => {
                    this._log.info("FolderTreeWidgetInstanceClass._filterDocuments()");
                    let filterText = this._filterInput.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering documents with: " + filterText);
                    }
                    this._dataTree.filterLeaves(filterText);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("FolderTreeWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("FolderTreeWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("FolderTreeWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = config;
                if (conf.hasOwnProperty('OpenedFolderIcon') && conf.OpenedFolderIcon.length > 0) {
                    this._openedFolderIcon = conf.OpenedFolderIcon;
                }
                if (conf.hasOwnProperty('ClosedFolderIcon') && conf.ClosedFolderIcon.length > 0) {
                    this._closedFolderIcon = conf.ClosedFolderIcon;
                }
                if (conf.hasOwnProperty('DocumentIcon') && conf.DocumentIcon.length > 0) {
                    this._documentIcon = conf.DocumentIcon;
                }
                if (conf.hasOwnProperty('DisplayDocumentsBeforeFolders') && conf.DisplayDocumentsBeforeFolders) {
                    this._displayDocumentsBeforeFolders = conf.DisplayDocumentsBeforeFolders;
                }
                if (conf.hasOwnProperty('MaxFolders') && conf.MaxFolders) {
                    this._maxFolders = conf.MaxFolders;
                }
                if (conf.hasOwnProperty('MaxDocuments') && conf.MaxDocuments) {
                    this._maxDocuments = conf.MaxDocuments;
                }
                if (conf.hasOwnProperty('ActivateIntoSlots') && (conf.ActivateIntoSlots != null) && (conf.ActivateIntoSlots.length > 0))
                    this._activateIntoSlots = conf.ActivateIntoSlots;
            }
        }
        FolderTreeWidgetInstanceClass.HtmlData = null;
        FolderTreeWidgetInstanceClass.ModalHtmlData = null;
        Widgets.FolderTreeWidgetInstanceClass = FolderTreeWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
